<template>
    <div>
        <div class="font-weight-bold">
            开始日期: {{ single.recurrent_info.date_start }} 结束时间: {{ single.recurrent_info.date_end }}
            {{ single.recurrent_info.repeat | repeatMeaning }}
            <span v-if="single.recurrent_info.original">
                    <br/> 建会账户: ({{ single.recurrent_info.original }})</span>
        </div>
        <div class="clearfix mb-3"></div>
        <el-table
            size="mini"
            :data="single.recurrent_info.meeting_times"
            :default-sort="{prop: 'date', order: 'asc'}"
            empty-text="没有数据。"
        >
            <el-table-column
                label="开始时间"
                prop="time">
                <template #default="props">
                    {{ props.row.time.slice(0, 19) }}
                </template>
            </el-table-column>
            <el-table-column
                label="结束时间"
                prop="time">
                <template #default="props">
                    {{ props.row.time.slice(-19) }}
                </template>
            </el-table-column>
            <el-table-column
                label="状态"
                prop="time">
                <template #default="props">
                            <span
                                :class="props.row.date >= new Date().Format('yyyy-MM-dd')?'text-primary':'text-muted'">
                                 {{ props.row.time | meetingStatues }}
                            </span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
    name: 'meeting-view-recurrent-info',
    props: {
        single: {}
    },
    filters: {
        meetingStatues(value) {
            // 截取value的1-19位字符
            const start = value.slice(0, 19);
            // 截取value的倒数19位字符
            const end = value.slice(-19);
            const meeting_start = new Date(start.replace(/-/g, '/'));
            const meeting_end = new Date(end.replace(/-/g, '/'));
            const now = new Date();

            if (now < meeting_start) return '未开始';
            if (now > meeting_end) return '已结束';

            return '正在进行';
        },
        repeatMeaning(value) {
            if (value == '1') return '每天循环';
            if (value == '2') return '每周循环';
            if (value == '3') return '每月循环';
            return '不重复';
        }
    },
}
</script>
